import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import "@/lib/axiosBootstrap";  // Phase 57b — dedupes redundant /auth/me thundering-herd (4-7x → 1).
import { AppErrorBoundary } from "@/lib/sentry";  // Initializes Sentry if REACT_APP_SENTRY_DSN is set; no-op otherwise.
import "@/i18n";        // Phase 54 — i18n bootstrap (English + Hindi). Must run before App.
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>,
);
